var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 27.504,
    height: 28.517,
    viewBox: "0 0 27.504 28.517",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.859,
    y1: 0.901,
    x2: 0.06,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#40eefe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b402f6"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_8",
    "data-name": "Union 8",
    d: "M6.323,28.517a4.347,4.347,0,0,1-4.334-4.335V13.9A3.665,3.665,0,0,1,0,10.649V8.66A1.113,1.113,0,0,1,.1,8.2L3.445.669A1.126,1.126,0,0,1,4.474,0H23.03a1.126,1.126,0,0,1,1.029.669L27.407,8.2a1.113,1.113,0,0,1,.1.457v1.988a3.667,3.667,0,0,1-1.989,3.25V24.182a4.347,4.347,0,0,1-4.334,4.335ZM18.266,17.569a1.127,1.127,0,0,1,1.125,1.126v7.571h1.789a2.089,2.089,0,0,0,2.083-2.083V14.252a3.639,3.639,0,0,1-1.936-.968,3.645,3.645,0,0,1-5.051,0,3.644,3.644,0,0,1-5.051,0,3.645,3.645,0,0,1-5.051,0,3.636,3.636,0,0,1-1.936.968v9.931a2.089,2.089,0,0,0,2.083,2.083H8.113V18.695a1.127,1.127,0,0,1,1.126-1.126Zm-7.9,8.7h6.777V19.821H10.364ZM22.454,10.648a1.4,1.4,0,1,0,2.8,0V9.784h-2.8Zm-5.052,0a1.4,1.4,0,1,0,2.8,0V9.785H17.4Zm-5.051,0a1.4,1.4,0,1,0,2.8,0V9.785h-2.8Zm-5.051,0a1.4,1.4,0,1,0,2.8,0V9.785H7.3Zm-5.05,0a1.4,1.4,0,1,0,2.8,0V9.785h-2.8Zm.607-3.114H24.647L22.3,2.251H5.206Z",
    fill: "url(#linear-gradient)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/shop.e65a113c2af29b065dc3d4e266a96f6f.svg";
export { ForwardRef as ReactComponent };